export default __webpack_public_path__ + "static/media/Background 5_00031.eb520680.png";